module.exports = __webpack_public_path__ + "static/media/icon_cold water.8da561da.svg";